import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Image } from "theme-ui";
import plusIcon from "../assets/images/Icon/plus.svg";
import cloneIcon from '../assets/images/Icon/clone.svg';
import crossIcon from "../assets/images/Icon/cross.svg";
import { projectAction } from "../../store/actions/project.action";
import { Overlay, Popover } from "react-bootstrap";
import { ActionOnHold } from "../Actions/ActionModule/ActionOnHold";
import { ActionProjectSetup } from "../Actions/ActionModule/ActionProjectSetup";
import theme from "../../theme";
import ActionConfirmation from "../Actions/ActionModule/ActionConfirmation";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ActionCreateByUrl } from '../../store/actions/CommonAction';
import { useNavigate } from 'react-router-dom';

export default function ProjectAction({ selectedTab, projectId, colorMode }: any) {
    const [textareaValue, setTextareaValue] = useState("");
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [selectedHighlight, setSelectedHighlight] = useState<any>(null);
    const { highlighterByView } = useSelector((state: any) => state.project);
    const popoverRef = useRef<HTMLDivElement>(null);
    const [target, setTarget] = useState(null);
    const [Open, setOpen] = useState(false);
    const [showCloneConfirmation, setShowCloneConfirmation] = useState(false);
    const dispatch = useDispatch();
    const highlightsHover = colorMode === "light" ? " #f7efe5" : " #515568";
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const navigate = useNavigate();

    const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextareaValue(event.target.value);
    };
    const openCloneConfirmation = () => setShowCloneConfirmation(true);
    const cancelCloneConfirmation = () => setShowCloneConfirmation(false);
    const confirmCloneProject = () => {
        dispatch(
            ActionCreateByUrl(
                {
                    Query: `project/create-clone/${projectId}`,
                    obj: { projectId },
                },
                (res: any) => {
                    if (res.status) {
                        navigate('/project');
                    }
                }
            )
        );
        setShowCloneConfirmation(false);
    };
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={cancelCloneConfirmation}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    const manualCloneAction = {
        name: 'Clone Project',
        icon: cloneIcon, // Use imported clone icon
        color: '#1976d2',
        onClick: openCloneConfirmation,
    };
    const highlightsWithClone = [
        ...(Array.isArray(highlighterByView) ? highlighterByView : []),
        manualCloneAction,
    ];

    const handleSend = () => {
        const payload = {
            actionType: selectedHighlight?.name,
            payload: {
                description: textareaValue
            }
        }
        dispatch(projectAction(payload, projectId))
        setOpen(false);
        setTextareaValue("")
        setSelectedHighlight(null)
    };

    // Function to handle click on highlight name
    const handleHighlightClick = (highlight: any) => {
        setSelectedHighlight(highlight);
        setOpen(true);
        setIsPopoverOpen(!isPopoverOpen)
    };
    const togglePopover = (event: any) => {
        setIsPopoverOpen(!isPopoverOpen);
        setTarget(event.target);

    };
    const handleClickOutside = (event: any) => {

        if (!event.target.closest('.popover-body')) {

            if (!event.target.closest('.toggle-btn')) {
                setIsPopoverOpen(false);
            }
        }

    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (
        <div ref={popoverRef}>
            <Overlay
                show={isPopoverOpen}
                target={target}
                placement="left"
            >
                <Popover style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden", background: colorMode === "light" ? "#fff" : "#20283c" }} id={`popover-positioned`} >
                    <Popover.Body className="w-auto">
                        {highlightsWithClone?.map((highlight: any, index: number) => {
                            return (
                                <Box
                                    key={index}
                                    sx={{
                                        color: highlight?.color, padding: "12px", borderRadius: "8px", cursor: 'pointer', '&:hover': {
                                            backgroundColor: highlightsHover
                                        }
                                    }}
                                    onClick={(e: any) => {
                                        togglePopover(e)
                                        highlight.onClick
                                            ? highlight.onClick()
                                            : handleHighlightClick(highlight);
                                    }}
                                >
                                    {highlight?.icon && <img width={22} src={typeof highlight.icon === 'string' ? highlight.icon : highlight.icon.default || highlight.icon} alt='' />} &nbsp;{highlight?.name}                            </Box>
                            );
                        })}
                    </Popover.Body>
                </Popover>
            </Overlay >
            <button className='btn toggle-btn' style={{ backgroundColor: selectedTab === 'action' ? `${theme?.colors?.lightbackground}` : 'inherit', padding: "0px" }} onClick={togglePopover}>
                {isPopoverOpen ? <Image src={crossIcon} alt='' style={{ fill: selectedTab === 'action' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    : <Image src={plusIcon} alt='' style={{ fill: selectedTab === 'action' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />}
            </button>
            {selectedHighlight?.name === "On Hold" && <ActionOnHold selectedHighlight={selectedHighlight} Open={Open} setOpen={setOpen} actionObject={{ projectId: projectId }} />}
            {selectedHighlight?.name === "Project Setup" && <ActionProjectSetup selectedHighlight={selectedHighlight} Open={Open} setOpen={setOpen} actionObject={{ projectId: projectId }} />}
            {selectedHighlight?.name === "Waiting for CAD" && <ActionConfirmation selectedHighlight={selectedHighlight} Open={Open} setOpen={setOpen} actionObject={{ projectId: projectId }} />}
            {/* Clone Project Confirmation Modal */}
            <Modal isOpen={showCloneConfirmation} toggle={cancelCloneConfirmation} size="sm" centered>
                <ModalHeader toggle={cancelCloneConfirmation} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>Confirm Clone</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    {`Are you sure you want to clone this project?`}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: 'pointer' }} onClick={cancelCloneConfirmation}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: 'pointer' }} onClick={confirmCloneProject}>Yes</Button>
                </ModalFooter>
            </Modal>
        </div >
    );
}
